import React from "react";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { contactFormText } from "i18n/contactCTA";

const ContactFormPage = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const session = searchParams.get("session");

  const lang = useSelector((state) => state.language.lang);

  const t = contactFormText[lang];

  return (
    <section className="min-h-screen bg-[#ebe5de] py-20 px-4">
      <div className="max-w-4xl mx-auto">
        {/* BACK */}
        <button
          onClick={() => navigate("/contact")}
          className="inline-flex items-center gap-2 text-reddark hover:text-black transition my-8"
        >
          <ArrowLeft size={18} />
          Back
        </button>

        {/* CARD */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="
            relative overflow-hidden
            rounded-[2.5rem]
            border border-white/60
            bg-white/80 backdrop-blur-2xl
            p-6 md:p-10
            shadow-[0_20px_80px_rgba(0,0,0,0.08)]
          "
        >
          {/* glow */}
          <div className="absolute top-0 right-0 w-60 h-60 bg-reddark/5 blur-3xl rounded-full" />

          <div className="relative z-10">
            <span className="inline-flex rounded-full bg-reddark/10 text-reddark px-4 py-2 text-sm font-medium mb-5">
              Business Enquiry
            </span>

            <h1 className="text-4xl md:text-6xl font-[Crimson] text-reddark leading-[0.95] tracking-[-0.04em] mb-5">
              {t.book}
            </h1>

            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              {t.formIntro}
            </p>

            {/* FORM */}
            <form className="grid gap-5">
              <div className="grid md:grid-cols-2 gap-5">
                {/* Name */}
                <div>
                  <label className="text-sm text-gray-600 block mb-2">
                    {t.name}
                  </label>

                  <input
                    className="
        w-full rounded-2xl
        border border-gray-200
        bg-white
        px-5 py-4
        outline-none
        transition
        focus:border-reddark
        focus:ring-4 focus:ring-reddark/10
      "
                  />
                </div>

                {/* Phone */}
                <div>
                  <label className="text-sm text-gray-600 block mb-2">
                    {t.tel}
                  </label>

                  <input
                    className="
        w-full rounded-2xl
        border border-gray-200
        bg-white
        px-5 py-4
        outline-none
        transition
        focus:border-reddark
        focus:ring-4 focus:ring-reddark/10
      "
                  />
                </div>

                {/* Email */}
                <div>
                  <label className="text-sm text-gray-600 block mb-2">
                    {t.email}
                  </label>

                  <input
                    className="
        w-full rounded-2xl
        border border-gray-200
        bg-white
        px-5 py-4
        outline-none
        transition
        focus:border-reddark
        focus:ring-4 focus:ring-reddark/10
      "
                  />
                </div>

                {/* Company */}
                <div>
                  <label className="text-sm text-gray-600 block mb-2">
                    {t.company}
                  </label>

                  <input
                    className="
        w-full rounded-2xl
        border border-gray-200
        bg-white
        px-5 py-4
        outline-none
        transition
        focus:border-reddark
        focus:ring-4 focus:ring-reddark/10
      "
                  />
                </div>
              </div>

              <div>
                <label className="text-sm text-gray-600 block mb-2">
                  {t.subject}
                </label>

                <textarea
                  rows="5"
                  defaultValue={session || ""}
                  className="
                    w-full rounded-2xl
                    border border-gray-200
                    bg-white
                    px-5 py-4
                    outline-none
                    transition
                    focus:border-reddark
                    focus:ring-4 focus:ring-reddark/10
                  "
                />
              </div>

              <div>
                <label className="text-sm text-gray-600 block mb-2">
                  {t.timetable}
                </label>

                <input
                  placeholder={t.timetablePlaceholder}
                  className="
                    w-full rounded-2xl
                    border border-gray-200
                    bg-white
                    px-5 py-4
                    outline-none
                    transition
                    focus:border-reddark
                    focus:ring-4 focus:ring-reddark/10
                  "
                />
              </div>

              <motion.button
                whileHover={{ scale: 1.01 }}
                whileTap={{ scale: 0.99 }}
                className="
                  mt-4
                  w-full
                  rounded-2xl
                  bg-reddark
                  py-5
                  text-white
                  font-semibold
                  shadow-xl
                  hover:bg-black
                  transition-all duration-300
                "
              >
                {t.submit}
              </motion.button>
            </form>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactFormPage;
